export default function LinkedInIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="ic linkedin">
        <g id="Union">
          <path
            d="M9.17076 10.4538V16.9031H7.02711V10.4538H9.17076Z"
            fill="currentColor"
          />
          <path
            d="M9.31174 8.45906C9.31174 9.07797 8.84646 9.5732 8.09892 9.5732H8.08495C7.36557 9.5732 6.90039 9.07797 6.90039 8.45906C6.90039 7.82622 7.37983 7.34473 8.11311 7.34473C8.84646 7.34473 9.2978 7.82622 9.31174 8.45906Z"
            fill="currentColor"
          />
          <path
            d="M12.5006 16.9031H10.3569C10.3569 16.9031 10.3851 11.0589 10.357 10.4538H12.5006V11.3669C12.4958 11.3743 12.491 11.3817 12.4863 11.3891H12.5006V11.3669C12.7855 10.9274 13.2953 10.3024 14.4325 10.3024C15.8428 10.3024 16.9004 11.2242 16.9004 13.2051V16.9031H14.7569V13.4529C14.7569 12.5859 14.4466 11.9944 13.671 11.9944C13.0788 11.9944 12.7261 12.3933 12.5711 12.7784C12.5145 12.9162 12.5006 13.1088 12.5006 13.3015V16.9031Z"
            fill="currentColor"
          />
        </g>
        <rect
          id="Rectangle 1654"
          x="4"
          y="4"
          width="16"
          height="16"
          rx="2.5"
          stroke="currentColor"
          strokeWidth="2"
        />
      </g>
    </svg>
  )
}

export function LinkedInIconSmall() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.64197 8.71165V14.0861H7.8556V8.71165H9.64197Z" fill="white" />
      <path
        d="M9.75945 7.0494C9.75945 7.56515 9.37172 7.97785 8.74878 7.97785H8.73713C8.13765 7.97785 7.75 7.56515 7.75 7.0494C7.75 6.52204 8.14953 6.12079 8.7606 6.12079C9.37172 6.12079 9.74784 6.52204 9.75945 7.0494Z"
        fill="currentColor"
      />
      <path
        d="M12.4168 14.0861H10.6304C10.6304 14.0861 10.6539 9.21595 10.6305 8.71165H12.4168V9.47257C12.4128 9.47879 12.4088 9.48496 12.4049 9.49108H12.4168V9.47257C12.6542 9.10635 13.0791 8.58553 14.0267 8.58553C15.202 8.58553 16.0833 9.35367 16.0833 11.0045V14.0861H14.2971V11.2109C14.2971 10.4884 14.0385 9.99554 13.3921 9.99554C12.8987 9.99554 12.6047 10.3279 12.4756 10.6489C12.4284 10.7637 12.4168 10.9242 12.4168 11.0848V14.0861Z"
        fill="currentColor"
      />
      <rect
        x="5.33333"
        y="3.33333"
        width="13.3333"
        height="13.3333"
        rx="2.08333"
        stroke="currentColor"
        strokeWidth="1.66667"
      />
    </svg>
  )
}
